export default {
  "agentApproval.title": "提现审批",
  "agentApproval.thead.index": "#序号",
  "agentApproval.thead.applyId": "申请ID",
  "agentApproval.thead.userno": "用户编号",
  "agentApproval.thead.email": "邮箱",
  "agentApproval.thead.statusDesc": "状态",
  "agentApproval.thead.applyTime": "申请时间",
  "agentApproval.thead.action": "操作",
  "agentApproval.tooltip.copyUserNo": "复制用户ID",
  "agentApproval.tooltip.userDetails": "用户详细信息",
};
